import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";
import { Empty, Spin } from "antd";


const PosBarChart = (props) => {

  const data = props.data;

  if (data.length === 0 && !props.isLoading) {
    return <Empty description="Veri Yok" />;
  }

  if (props.isLoading) {
    return (
      <div     style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "500px", // Kartın tamamını kaplaması için
      }}>
        <Spin size="small" />
      </div>
    );
  }

  const config = {
    data,
    xField: props.xField, // X ekseni: Tutar
    yField: props.yField, // Y ekseni: Bankalar
    color: ["#0047ca"], // Burada HER ÇUBUK için rastgele renk atanıyor
    legend: false,
    yAxis: {
      title: props.showYTitle ? {
        text: props.yTitle, // X ekseni başlığı
        style: {
          fontSize: 14,
          fontWeight: "bold",
        }
      } : null,
      label: {
        formatter: (v) => props.isAmount ?  new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
          minimumFractionDigits: 2,
        }).format(v) : v
      },
    },
    xAxis: {
      title: props.showXTitle ? {
        text: props.xTitle, // X ekseni başlığı
        style: {
          fontSize: 14,
          fontWeight: "bold",
        }
      } : null,
      label: {
        rotate: -45, // X eksenindeki banka adlarını çapraz yaz
        style: {
          fontSize: 12,
          fontWeight: "bold",
          textAlign: "right",
        },
      },
    },
    tooltip: props.showTooltip
      ? {
        formatter: (datum) => ({
          name: [props.toolTipName],
          value:  props.toolTipIsAmount ? new Intl.NumberFormat("tr-TR", {
            style: "currency",
            currency: "TRY",
            minimumFractionDigits: 2,
          }).format(datum[props.toolTipValue]) : datum[props.toolTipValue],
        }),
      }
      : false,
    label: {
      position: "top", // Label sağ tarafa sabitlendi
      style: {
        fill: "#000", // Siyah renk
        fontSize: 11, // Yazı boyutu
      },
      formatter: (datum) => props.isAmount ? new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
        minimumFractionDigits: 2,
      }).format(datum[props.label]) : datum[props.label]
    },
  };

  return <Column {...config} />;
}


export default PosBarChart;
